module.exports = __webpack_public_path__ + "static/media/tjt_mc.dfdfc33e.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/montemar/img/tjt_mc.png
 ** module id = 471
 ** module chunks = 0
 **/